if (!customElements.get('size-guide')) {
  customElements.define(
    'size-guide',
    class SizeGuide extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.trigger = this.querySelector('[data-size-guide-open]');
        this.dialog = this.querySelector('[data-size-guide-dialog]');
        if (!this.trigger || !this.dialog) return;

        this.applyColorScheme();
        this.trigger.addEventListener('click', () => this.open());
        this.dialog.querySelectorAll('[data-size-guide-close]').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
          }
        });
      }

      disconnectedCallback() {
        if (this.dialog?.parentElement === document.body) {
          this.dialog.remove();
          document.body.classList.remove('overflow-hidden');
          if (typeof removeTrapFocus === 'function') removeTrapFocus();
        }
      }

      applyColorScheme() {
        const source = this.closest('[class*="color-"]');
        if (!source) return;
        source.classList.forEach((className) => {
          if (className.startsWith('color-')) this.dialog.classList.add(className);
        });
      }

      open() {
        if (this.isOpen) return;
        this.isOpen = true;
        this.placeholder = document.createComment('size-guide-dialog');
        this.dialog.before(this.placeholder);
        document.body.appendChild(this.dialog);
        this.dialog.hidden = false;
        this.dialog.setAttribute('open', '');
        this.trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden');

        const closeButton = this.dialog.querySelector('[data-size-guide-close]');
        if (typeof trapFocus === 'function') {
          trapFocus(this.dialog, closeButton);
        } else {
          closeButton?.focus();
        }
      }

      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.dialog.hidden = true;
        this.dialog.removeAttribute('open');
        if (this.placeholder?.parentNode) this.placeholder.replaceWith(this.dialog);
        this.placeholder = null;
        this.trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden');

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.trigger);
        } else {
          this.trigger.focus();
        }
      }
    }
  );
}
